module.exports = __webpack_public_path__ + "img/3e29114.jpg";